import React from "react";
import { FaYoutube } from "react-icons/fa";

const channels = [
    {
        name: "Barry KDP - Best Ever!",
        url: "https://www.youtube.com/@barrygeorgioukdp",
    },
    {
        name: "Sean Dollwet - Must Watch!",
        url: "https://www.youtube.com/@SeanDollwet",
    },
    {
        name: "Dane McBeth Publishing - Fresh Ideas!",
        url: "https://www.youtube.com/@DaneMcBeth",
    },
    {
        name: "Rachel Harrison-Sund LowContent Books",
        url: "https://www.youtube.com/@RachelHarrisonSund",
    },
    {
        name: "Emeka Ossai - KDP Mastery",
        url: "https://www.youtube.com/@selfpublishingprofits",
    },
    {
        name: "Self Publishing with Dale - How To",
        url: "https://www.youtube.com/c/SelfPublishingwithDale",
    },
    {
        name: "Ben McQueeney - KDP & AI",
        url: "https://www.youtube.com/@benmcqueeney",
    },
    {
        name: "Kindlepreneur - Book Marketing",
        url: "https://www.youtube.com/c/Kindlepreneur",
    },
    {
        name: "Ben Chinnock - KDP & Low Content",
        url: "https://www.youtube.com/@BENCHINNOCK",
    },
    {
        name: "Ivy Hang - Making Coloring Books",
        url: "https://www.youtube.com/@ivyhang5084",
    },

];

const RecommendedChannels = () => {
    return (
        <div>
            <h6 className="fw-bold text-muted mb-3">📺 Recommended YouTube Channels</h6>
            <ul className="list-group">
                {channels.map((ch) => (
                    <li
                        key={ch.url}
                        className="list-group-item list-group-item-action"
                        style={{ padding: "0.5rem 0.75rem" }}
                    >
                        <a
                            href={ch.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-decoration-none text-reset d-flex align-items-center"
                        >
                            <FaYoutube className="me-2 text-danger" />
                            <span className="small fw-semibold">{ch.name}</span>
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default RecommendedChannels;
